class MadDownloadListFilter {
  constructor(container) {
    this.container = container;
    this.searchInput = container.querySelector('.mad-download-list__filter-search');
    this.categorySelect = container.querySelector('.mad-download-list__filter-category');
    this.productSelect = container.querySelector('.mad-download-list__filter-product');
    this.resetButton = container.querySelector('.mad-download-list__filter-reset');
    this.groups = container.querySelectorAll('.mad-download-list__group');
    this.items = container.querySelectorAll('.mad-download-list__item');
    this.init();
  }

  init() {
    if (this.searchInput) {
      this.searchInput.addEventListener('input', () => this.filter());
    }
    if (this.categorySelect) {
      this.categorySelect.addEventListener('change', () => {
        if (this.productSelect) this.productSelect.value = '';
        this.updateProductVisibility();
        this.filter();
      });
    }
    if (this.productSelect) {
      this.productSelect.addEventListener('change', () => this.filter());
    }
    if (this.resetButton) {
      this.resetButton.addEventListener('click', () => {
        this.reset();
        this.updateProductVisibility();
      });
    }
    // Initial state
    this.updateProductVisibility();
  }

  updateProductVisibility() {
    if (!this.productSelect) return;
    const category = this.categorySelect ? this.categorySelect.value : '';
    if (!category) {
      this.productSelect.style.visibility = 'hidden';
      if (this.resetButton) this.resetButton.style.visibility = 'hidden';
      return;
    }
    // Check if there are products for this category
    let hasProduct = false;
    this.items.forEach(item => {
      let catTitle = item.querySelector('.mad-download-list__item-category-title')?.textContent || '';
      catTitle = catTitle.replace(/\u00A0/g, '').trim();
      if (catTitle === this.categorySelect.options[this.categorySelect.selectedIndex].text) {
        let prodTitle = item.querySelector('.mad-download-list__item-product-title')?.textContent || '';
        prodTitle = prodTitle.replace(/\u00A0/g, '').trim();
        if (prodTitle !== '') {
          hasProduct = true;
        }
      }
    });
    this.productSelect.style.visibility = hasProduct ? 'visible' : 'hidden';
    if (this.resetButton) this.resetButton.style.visibility = 'visible';
  }

  filter() {
    const search = this.searchInput ? this.searchInput.value.trim().toLowerCase() : '';
    const category = this.categorySelect ? this.categorySelect.value : '';
    const product = this.productSelect ? this.productSelect.value : '';

    this.items.forEach(item => {
      let text = item.textContent.toLowerCase();
      let catMatch = true;
      let prodMatch = true;
      let searchMatch = true;

      // Category filter
      if (category) {
        let catTitle = item.querySelector('.mad-download-list__item-category-title')?.textContent || '';
        catTitle = catTitle.replace(/\u00A0/g, '').trim();
        catMatch = catTitle === this.categorySelect.options[this.categorySelect.selectedIndex].text;
      }
      // Product filter
      if (product) {
        let prodTitle = item.querySelector('.mad-download-list__item-product-title')?.textContent || '';
        prodTitle = prodTitle.replace(/\u00A0/g, '').trim();
        prodMatch = prodTitle === this.productSelect.options[this.productSelect.selectedIndex].text;
      }
      // Search filter
      if (search) {
        searchMatch = text.includes(search);
      }
      if (catMatch && prodMatch && searchMatch) {
        item.style.display = '';
      } else {
        item.style.display = 'none';
      }
    });
    // hide empty groups
    this.groups.forEach(group => {
      const visible = group.querySelectorAll('.mad-download-list__item:not([style*="display: none"])').length > 0;
      group.style.display = visible ? '' : 'none';
    });
  }

  reset() {
    if (this.searchInput) this.searchInput.value = '';
    if (this.categorySelect) this.categorySelect.value = '';
    if (this.productSelect) this.productSelect.value = '';
    if (this.resetButton) this.resetButton.style.visibility = 'hidden';
    this.filter();
  }
}

jQuery(document).ready(() => {
  document.querySelectorAll('.mad-download-list').forEach(container => {
    new MadDownloadListFilter(container);
  });
});
